import React from 'react';
import { render } from 'react-dom';
import TaxonomyList from './apps/TaxonomyList/TaxonomyList';

// Taxonomy for Categories (Main & Sub) Application
const taxonomyList = document.getElementById('taxonomy-list-app');
if (taxonomyList) render(<TaxonomyList {...taxonomyList.dataset} />, taxonomyList);
